import { render } from "./ShowHeader.vue?vue&type=template&id=1f0c8a06&scoped=true"
import script from "./ShowHeader.vue?vue&type=script&lang=js"
export * from "./ShowHeader.vue?vue&type=script&lang=js"

import "./ShowHeader.vue?vue&type=style&index=0&id=1f0c8a06&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0c8a06"]])

export default __exports__